import { render } from "./RoutedNavigationBar.vue?vue&type=template&id=befb69b0&scoped=true&ts=true"
import script from "./RoutedNavigationBar.vue?vue&type=script&lang=ts"
export * from "./RoutedNavigationBar.vue?vue&type=script&lang=ts"

import "./RoutedNavigationBar.vue?vue&type=style&index=0&id=befb69b0&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befb69b0"]])

export default __exports__